import { Group, Tabs, TabsItem, Footer } from '@vkontakte/vkui';
import React from 'react';
import { CreditRowComponent, DebtorRowComponent } from './CreditRowComponent';
import PropTypes from 'prop-types';
import { CreatorType, CreditorTypeV4 } from '../../../Types';
import { useAppContext } from '../../../AppContext';

const TAB__I = 'i'
const TAB__ME = 'me';
const TAB__ALL = 'all';

const CURRENT_COMPONENT = 'CreditsBlockComponent';
const CreditsBlockComponent = ({panel, credits, members, onClickAddRepayment, emptyListLabel}) => {
  if (credits.length < 1) {
    return (<></>);
  }

  const context = useAppContext();
  const [selected, setSelected] = React.useState(TAB__I);

  const result = {};
  (credits || []).forEach((row) => {
    if (selected === TAB__I) {
      if (!result[row.debtor_id]) {
        result[row.debtor_id] = [];
      }
      result[row.debtor_id].push({
        creditor_id: row.creditor_id,
        debtor_id: row.debtor_id,
        amount: row.amount,
      });
    } else if (selected === TAB__ME) {
      if (!result[row.creditor_id]) {
        result[row.creditor_id] = [];
      }
      result[row.creditor_id].push({
        creditor_id: row.creditor_id,
        debtor_id: row.debtor_id,
        amount: row.amount,
      });
    } else {
      if (!result[row.debtor_id]) {
        result[row.debtor_id] = [];
      }

      result[row.debtor_id].push({
        creditor_id: row.creditor_id,
        debtor_id: row.debtor_id,
        amount: row.amount,
      });
    }
  });

  return (
    <Group className={"CreditsBlockComponent"} style={{paddingBottom: 12}}>
      <Tabs
        withScrollToSelectedTab
        scrollBehaviorToSelectedTab="center"
      >
        <TabsItem
          selected={selected === TAB__I}
          onClick={() => setSelected(TAB__I)}
        >
          {context.lang().getKey(CURRENT_COMPONENT, 'tab_i')}
        </TabsItem>
        <TabsItem
          selected={selected === TAB__ME}
          onClick={() => setSelected(TAB__ME)}
        >
          {context.lang().getKey(CURRENT_COMPONENT, 'tab_me')}
        </TabsItem>
        <TabsItem
          selected={selected === TAB__ALL}
          onClick={() => setSelected(TAB__ALL)}
        >
          {context.lang().getKey(CURRENT_COMPONENT, 'tab_all')}
        </TabsItem>
      </Tabs>
      {
        selected === TAB__I && (result[context.store.currentUserId] || []).length < 1 && (<Footer>{emptyListLabel}</Footer>)
      }
      {
        selected === TAB__I && ((result[context.store.currentUserId] || []).map((row) => (<DebtorRowComponent
          key={'debtor_i__' + row.creditor_id}
          panel={panel}
          user={members[row.creditor_id]}
          amount={row.amount}
          onClickButton={() => onClickAddRepayment(row.creditor_id, row.debtor_id)}
          buttonMode={'primary'}
        />)))
      }
      {
        selected === TAB__ME && (result[context.store.currentUserId] || []).length < 1 && (<Footer>{emptyListLabel}</Footer>)
      }
      {
        selected === TAB__ME && ((result[context.store.currentUserId] || []).map((row) => (<DebtorRowComponent
          key={'creditor_i__' + row.debtor_id}
          panel={panel}
          user={members[row.debtor_id]}
          amount={row.amount}
          onClickButton={() => onClickAddRepayment(row.creditor_id, row.debtor_id)}
        />)))
      }
      {
        selected === TAB__ME && (Object.keys(result)).length < 1 && (<Footer>{emptyListLabel}</Footer>)
      }
      {
        selected === TAB__ALL && ((Object.keys(result)).map((userId) => {
          return (<CreditRowComponent
            key={'user_' + userId}
            panel={panel}
            userId={Number(userId)}
            creditors={result[userId]}
            members={members}
            onClickAddRepayment={onClickAddRepayment}
            createRepaymentButtonMode={(row) => context.store.currentUserId === row.debtor_id}
          />);
        }))
      }
    </Group>
  );
}

export default CreditsBlockComponent;

CreditsBlockComponent.propTypes = {
  panel: PropTypes.string.isRequired,
  emptyListLabel: PropTypes.string.isRequired,
  credits: PropTypes.arrayOf(CreditorTypeV4).isRequired,
  members: PropTypes.objectOf(CreatorType).isRequired,
  onClickAddRepayment: PropTypes.func.isRequired,
};
